/**
 * Утилиты для работы с изображениями
 */

import { FALLBACK_IMAGES } from '@/constants'

/**
 * Обработчик ошибки загрузки изображения
 * Устанавливает fallback изображение при ошибке загрузки
 * @param {Event} event - Событие ошибки загрузки изображения
 */
export function handleImageError(event) {
  if (event && event.target) {
    event.target.src = FALLBACK_IMAGES.NO_IMAGE
  }
}

